import Vue from 'vue'
import _ from 'lodash'

Vue.filter('fileSizeParseFilter', (input) => {
  if (input >= 1073741824) {
    return (Math.ceil(input / 1073741824 * 100) / 100) + 'GB'
  } else if (input >= 1048576) {
    return (Math.ceil(input / 1048576 * 100) / 100) + 'MB'
  } else if (input >= 1024) {
    return (Math.ceil(input / 1024 * 100) / 100) + 'KB'
  } else {
    return input + 'B'
  }
})

// 时间戳转时间
Vue.filter('timestampToTime', (timestamp) => {
  const date = new Date(timestamp * 1000)
  const Y = date.getFullYear() + '-'
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
})

// 时间格式化
Vue.filter('dateParse', (timestamp, type) => {
  if (!timestamp) {
    return '-- --'
  }
  const date = new Date(timestamp)
  let Y = date.getFullYear() + '-'
  if (type === 2) {
    Y = Y.substr(2)
  }
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  if (type === 3) {
    return Y + M + D
  }
  if (type === 4) {
    return h + m + s
  }
  return Y + M + D + ' ' + h + m + s
})

// 毫秒倒计时
Vue.filter('timeDown', (timestamp) => {
  const hours = Math.floor(timestamp / 3600)
  const minutes = Math.floor((timestamp % 3600) / 60)
  const seconds = Math.floor((timestamp % 3600) % 60)
  return ` ${hours} 小时 ${minutes} 分 ${seconds} 秒`
})

Vue.filter('parseHtmlFilter', (htmlstr) => {
  return (htmlstr.replace(/<\/?[^>]*>/ig, '')).replace(/&nbsp;/ig, '')
})

Vue.filter('strSliceFilter', (htmlstr, len) => {
  return htmlstr.substring(0, len) + (htmlstr.length <= len ? '' : '......')
})

// 数字转化为保留两位小数的字符串100.00
Vue.filter('parseToMoney', (num, len) => {
  const numStr = num + ''
  return `${numStr.length < 3 ? '0' : numStr.substr(0, numStr.length - 2)}.${numStr.length === 1 ? ('0' + numStr) : numStr.substr(numStr.length - 2)}`
})

// 发票类型信息转文字
Vue.filter('PARSE_DATA_VALUE', (value, dataJson) => {
  let backName = ''
  _.forEach(dataJson, item => {
    if (item.value === value) {
      backName = item.label
      return false
    }
  })
  return backName
})

// 日志角色信息转换
Vue.filter('PARSE_LOG_ROLE', (logItem, LOG_ROLE) => {
  switch (logItem['logRole']) {
    case LOG_ROLE.SYSTEM.value:
      return ''
    case LOG_ROLE.USER.value:
      return `${logItem['user']['userName']}`
    case LOG_ROLE.SHOP.value:
      return `${logItem['shopAdmin']['adminName']}`
    case LOG_ROLE.PLATFORM.value:
      return `${logItem['platformAdmin']['adminName']}`
    default:
      return 'NAN'
  }
})



// WEBPACK FOOTER //
// ./src/utils/filters.js